import { PropsWithChildren } from "react";
import NoDataIndicator from "../NoDataIndicator/NoDataIndicator";
import styles from "./EmailLink.module.css";

type EmailLinkProps = { email?: string };

const ClickableEmail = ({
  email,
  children,
  className,
}: PropsWithChildren<{ email: string; className: string }>) => (
  <a className={className} href={`mailto:${email}`}>
    {children}
  </a>
);

const EmailLink = ({ email }: EmailLinkProps) => {
  return (
    <div className="d-flex align-items-center">
      &nbsp;
      {email ? (
        <ClickableEmail email={email} className={styles.linkNoStyle}>
          <i className="far fa-envelope"></i>
        </ClickableEmail>
      ) : (
        <i className="far fa-envelope"></i>
      )}
      &nbsp;
      {email ? (
        <ClickableEmail
          email={email}
          className={`${styles.link} font-md cut-text`}
        >
          {email}
        </ClickableEmail>
      ) : (
        <NoDataIndicator />
      )}
    </div>
  );
};

export default EmailLink;
